import React, { Component } from "react"
import { SharedContext, SelectionManager, SelectionAction, locale } from "@albelli/photoselector"
import { PhotoOrganiserItem } from "../Components/CategoryItemContainer"
import loader from "@albelli/photoselector/lib/ImagePicker/Graphic/loader.svg"

interface SelectionButtonsState {
  loading: boolean // not sure if we need this one
}

interface SelectionButtonProps {
  hidden?: boolean
  totalItemsCount: number
  store: SelectionManager
  items: PhotoOrganiserItem[]
  getItems: Function
}

class SelectionButtons extends Component<SelectionButtonProps, SelectionButtonsState> {
  static contextType = SharedContext
  // FIXME: this should be coming from config perhaps?
  private maxAllowedPhotosForSelect = 1000
  private listenerHandler: (action: SelectionAction) => void = () => this.listener()

  constructor(props: SelectionButtonProps) {
    super(props)

    this.state = {
      loading: false
    }
  }

  componentDidMount() {
    // add listener to handle selections
    this.props.store.addListener(this.listenerHandler)
  }

  componentWillUnmount() {
    this.props.store.removeListener(this.listenerHandler)
  }

  listener() {
    // the listener is triggered when the selection was updated, therefore force rerender
    this.forceUpdate()
  }

  allPhotosSelected() {
    // TODO: need to check if all selected photos are there
    const { store, items } = this.props
    // store can contain items from all categories, we need to check if items of current category are selected
    const allSelected = items.find((item) => !store.isSelected(item))
    return !allSelected
  }

  // TODO: this has to be covered with tests
  loadAllPhotos() {
    // if not all images are selected, then we load them
    const { items, totalItemsCount, getItems } = this.props
    if (items.length === totalItemsCount) {
      return Promise.resolve(items)
    }

    // otherwise make several requests to get all items
    const options: { skip: number }[] = []
    // apparently requests are limited to 100 items only
    let skip = items.length
    while (skip < totalItemsCount) {
      options.push({ skip })
      // now we need to start iterating
      if (skip < totalItemsCount) {
        skip += 100
      }
    }

    const requests = options.map((option) => getItems(option))
    return Promise.all(requests).then((result) => items.concat(...result))
  }

  handleSelect() {
    if (this.hasExceededMaxPhotoLimit()) {
      return
    } else if (this.allPhotosSelected()) {
      this.deselectAll()
    } else {
      this.selectAll()
    }
  }

  selectAll() {
    this.setState({ loading: true })
    this.loadAllPhotos()
      .then((items) => {
        this.props.store.bulkSelect(items) // this will select all of it
        this.setState({ loading: false })
        return items
      })
      .catch((e) => console.error("Unable to select all photos.", e))
  }

  deselectAll() {
    this.setState({ loading: true })
    this.loadAllPhotos()
      .then((items) => {
        this.props.store.bulkDeselect(items)
        this.setState({ loading: false })
        return items
      })
      .catch((e) => console.error("Unable to deselect all photos.", e))
  }

  hasExceededMaxPhotoLimit() {
    return this.props.totalItemsCount > this.maxAllowedPhotosForSelect
  }

  render() {
    const { totalItemsCount } = this.props
    const { loading } = this.state
    const completeOnSelect = this.context ? this.context.completeOnSelect : false // completeOnSelect means that you select only one image, and then doneSelecting() is run automaticly.
    const selectAllClass = this.allPhotosSelected() ? "photoselector-deselect-all" : "photoselector-select-all"

    const selectionContainerClass = this.hasExceededMaxPhotoLimit()
      ? "photoselector-selection-container-exceeded"
      : "photoselector-selection-container"
    const imageCountClass = this.hasExceededMaxPhotoLimit() ? "photoselector-selection-image-count-exceeded" : "photoselector-selection-image-count"

    return (
      <div className={selectionContainerClass} onClick={() => this.handleSelect()} hidden={this.props.hidden || completeOnSelect}>
        <div className="photoselector-selection-button-container" hidden={this.hasExceededMaxPhotoLimit() || totalItemsCount === 0}>
          {loading ? <img className="photoselector-selection-loading" src={loader} /> : <div className={selectAllClass} data-tam="select-all"></div>}
        </div>

        <div className={imageCountClass} data-tam="select-all-count">
          <span>
            <strong>{locale.get().generic.all}</strong> ({totalItemsCount})
          </span>
        </div>
      </div>
    )
  }
}

export default SelectionButtons
